import styles from "./Menu.module.scss"

export function MenuDivider() {
    return <div className={styles.divider} data-testid="menu-divider" />
}
